import { useCallback, useState } from 'react';

interface UseClientDuplicateModalProps {
  onMerge: () => Promise<void>;
}

export const useClientDuplicateModal = ({
  onMerge,
}: UseClientDuplicateModalProps) => {
  const [isMerging, setIsMerging] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);

  const mergeHandler = useCallback(async () => {
    setIsMerging(true);
    try {
      await onMerge();
    } finally {
      setIsMerging(false);
    }
  }, [onMerge]);

  return { isMerging, isDisabled, mergeHandler, setIsDisabled };
};
